import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// styles
import styles from "./SNSBtnStyle";
const useStyles = makeStyles(styles);

export default function SNSBtn(props) {
  const classes = useStyles();
  return (
    <a
      href={props.url}
      className={classes.btnContainer}
      style={{ background: props.color }}
    >
      <div className={classes.icon}>
        <i className={props.icon}></i>
      </div>
    </a>
  );
}
